import {type Readable, writable} from 'svelte/store';
import {hasContext, getContext} from 'svelte';
import {createContext, getContextOrThrow} from 'src/core';

const INFINITE_SCROLL_CONTEXT_KEY = Symbol('infinite-scroll-context-key');

export interface InfiniteScrollContext {
    enabled: boolean;
    gridElementRef$: Readable<HTMLElement>;
    loading$: Readable<boolean>;
    setGridElementRef: (element: HTMLElement) => void;
    setLoading: (loading: boolean) => void;
}

export function createInfiniteScrollContext(enabled: boolean): InfiniteScrollContext {
    const gridElementRef$ = writable<HTMLElement>(null);
    const loading$ = writable(false);

    return createContext(INFINITE_SCROLL_CONTEXT_KEY, {
        enabled,
        gridElementRef$,
        loading$,
        setGridElementRef: (element) => gridElementRef$.set(element),
        setLoading: (loading) => loading$.set(loading)
    });
}

export function getInfiniteScrollContext(): InfiniteScrollContext {
    return getContextOrThrow(INFINITE_SCROLL_CONTEXT_KEY);
}

export function getInfiniteScrollContextIfExists(): InfiniteScrollContext | null {
    if (!hasContext(INFINITE_SCROLL_CONTEXT_KEY)) {
        return null;
    }

    return getContext(INFINITE_SCROLL_CONTEXT_KEY);
}